import PropTypes from 'prop-types';

export default {
  id: PropTypes.string,
  name: PropTypes.string,
  photo: PropTypes.shape({
    url: PropTypes.string
  }),
  track_quantity: PropTypes.bool,
  storage: PropTypes.number,
  retail_price: PropTypes.number,
  order_when_no_stock: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/model/Types/product.js